export type TimestampValue =
  | Date
  | number
  | string
  | { seconds?: number; milliseconds?: number };

export function parseTimestamp(value?: unknown): Date | null {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === "number") return new Date(value);
  if (typeof value === "string") {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  if (typeof value === "object") {
    const v = value as { seconds?: unknown; milliseconds?: unknown };
    if (typeof v.seconds === "number") {
      const date = new Date(v.seconds * 1000);
      if (!Number.isNaN(date.getTime())) return date;
    }
    if (typeof v.milliseconds === "number") {
      const date = new Date(v.milliseconds);
      if (!Number.isNaN(date.getTime())) return date;
    }
  }
  return null;
}

export function formatRelativeTime(date: Date): string {
  const diffMs = Math.max(0, Date.now() - date.getTime());
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return "just now";
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay}d ago`;
}
